// Define our theme structure first
interface ThemeColors {
  primary: string;
  secondary: string;
  background: string;
  backgroundSecondary: string;
  backgroundLight: string;
  backgroundHover: string;
  surface: string;
  text: string;
  textPrimary: string;
  textSecondary: string;
  textInverse: string;
  primaryLight: string;
  border: string;
  error: string;
  success: string;
  warning: string;
  info: string;
}

interface ThemeBorderRadius {
  xs: string;
  sm: string;
  md: string;
  lg: string;
  xl: string;
  circle: string;
  default: string;
}

interface ThemeShadows {
  sm: string;
  md: string;
  lg: string;
  xl: string;
  default: string;
}

interface ThemeTransitions {
  fast: string;
  normal: string;
  slow: string;
  default: string;
}

// Create our theme
import { DefaultTheme } from 'styled-components';

export const theme: DefaultTheme = {
  colors: {
    primary: '#FFD700',
    secondary: '#141414',
    background: '#000000',
    backgroundSecondary: '#0A0A0A',
    backgroundLight: '#1A1A1A',
    backgroundHover: '#2A2A2A',
    surface: '#1F1F1F',
    text: '#FFFFFF',
    textPrimary: '#FFFFFF',
    textSecondary: '#8C8C8C',
    textInverse: '#000000',
    primaryLight: '#FFF0A0',
    border: '#333333',
    error: '#FFD700',
    success: '#34C759',
    warning: '#FFCC00',
    info: '#007AFF',
  } as ThemeColors,
  breakpoints: {
    mobile: '320px',
    tablet: '768px',
    laptop: '1024px',
    desktop: '1440px',
  },
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    xxl: '3rem',
  },
  typography: {
    fontFamily: {
      primary: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    },
    fontSize: {
      xs: '0.75rem',
      sm: '0.875rem',
      md: '1rem',
      lg: '1.125rem',
      xl: '1.25rem',
      xxl: '1.5rem',
    },
    fontWeight: {
      regular: 400,
      medium: 500,
      bold: 700,
    },
    lineHeight: {
      tight: 1.2,
      normal: 1.5,
      loose: 1.8,
    },
  },
  borderRadius: {
    xs: '2px',
    sm: '4px',
    md: '8px',
    lg: '16px',
    xl: '24px',
    circle: '50%',
    default: '8px',
  } as ThemeBorderRadius,
  shadows: {
    sm: '0 1px 3px rgba(0, 0, 0, 0.12)',
    md: '0 4px 6px rgba(0, 0, 0, 0.16)',
    lg: '0 10px 15px rgba(0, 0, 0, 0.20)',
    xl: '0 20px 25px rgba(0, 0, 0, 0.24)',
    default: '0 4px 6px rgba(0, 0, 0, 0.16)',
  } as ThemeShadows,
  transitions: {
    fast: '0.2s ease',
    normal: '0.3s ease',
    slow: '0.5s ease',
    default: '0.3s ease',
  } as ThemeTransitions,
  zIndex: {
    modal: 1000,
    overlay: 900,
    dropdown: 800,
    header: 700,
    footer: 600,
  },
};